export { HospiceSearchResultContainer as default } from "containers/HospiceContainer";
